<template>
  <v-dialog class="paymentWindow" v-model="showPaymentWindow" width="650px" min-height="800px" persistent>
    <v-card height="100vh" style="overflow:scrollable;">
     <!-- <div>
          <v-card-title class="modal-headline" id="dialogTitle">Payment Details
            <v-spacer></v-spacer>
            <v-btn :ripple="false" icon ref="dialogHeaderCloseBtn" @click="cancelPayment" @keydown="dialogHeaderCloseKeydown($event)" aria-label="Close">
              <v-icon color="white">close</v-icon>
            </v-btn>
          </v-card-title>
      </div> -->
      <iframe ref="paymentIFrame" style="width:100%;height:100%;overflow:hidden;" scrollable=no :src="paymentUrl"></iframe>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { eventHub } from '../utils/eventhub'
import RestService from '../services/restService'

export default {
  name: 'PaymentNICAlabama',
  mixins: [RestService],
  props: [
    'totalCost',
    'email',
    'phone',
    'firstName',
    'lastName',
    'recaptchaToken',
    'securityToken'
  ],
  data: () => ({
    paymentUrl: '',
    showPaymentWindow: false,
    paymentOk: false,
    token: '',
    urlPaymentWindow: '',
    attemptCount: 0
  }),
  computed: {
    ...mapState([
      'configuration',
      'selectedServices',
      'selectedBranch',
      'servicesTranslations',
      'branchTranslations',
      'selectedDate',
      'selectedTimeSlot',
      'contactDetails', // check
      'reservedAppointmentId',
      'messages',
      'selectedLanguage',
      'funcDebug',
      'condTotalCost'
    ])
  },
  methods: {
    cancelPayment () {
      this.paymentOk = false
      this.showPaymentWindow = false
      // this.$emit('paymentOk', true, this.token)
    },
    sendPreparePayment () {
      var name = ''
      if (this.firstName || this.lastName) {
        if (this.firstName) name = this.firstName + ' '
        if (this.lastName) name += this.lastName
      }
      this.preparePayment(name, this.phone, this.email, this.totalCost,
        this.recaptchaToken, this.securityToken).then(response => {
        if (response && response.data && response.data.token) {
          this.paymentUrl = response.data.inContextRedirectUrl
          this.token = response.data.token
          this.showPaymentWindow = true
        } else if (response && response.data.message) {
          this.$emit('payment-failed')
        }
      })
    },
    closeModal () {
      this.showPaymentWindow = false
    },
    receiveMessage (evt) {
      if (!evt) {
        return
      }
      if (!evt.data) {
        return
      }

      // Check if event's origin is from CCP
      // iframeURL value is setup in the beginning of this javascript file
      // if using UAT, it could be https://securecheckout-uat..cdc.nicusa.com/Checkout/Payment?token=(token)
      if (this.paymentUrl.indexOf(evt.origin) > -1) {
        // additional logic
        if (evt.data.category === 'notification') {
          if (evt.data.messagedata.action === 'paymentsubmitted') {
            this.attemptCount = evt.data.messagedata.attemptcount
            // check the result of the payment
          } else {
            this.$emit('payment-cancelled')
          }
        } else if (evt.data.category === 'paymentresponse') {
          if (evt.data.messagedata.action === 'paymentsucceeded') {
            this.checkPayment(evt.data.messagedata.token).then(response => {
              if (response.data && response.data.message === 'ERROR') {
                this.$emit('payment-ok')
              } else {
                if (response.data.orders && response.data.orders.length > 0 && response.data.orders[0].fTrans.length > 0 &&
                  response.data.orders[0].fTrans[0].amount) {
                  var returnedCost = response.data.orders[0].fTrans[0].amount
                  var orderId = response.data.orders[0].orderId
                }
                this.$emit('payment-ok', returnedCost, orderId)
              }
            })
          } else if (evt.data.messagedata.action === 'paymentcancelled') {
            this.$emit('payment-cancelled')
          } else if (evt.data.messagedata.action === 'paymentfailed') {
            this.$emit('payment-failed')
          }
          this.closeModal()
        }
      } else {
        // you are not whitelisted, do nothing
      }
    }
  },
  mounted () {
    eventHub.$on('initPaymentNICAlabama', (payload) => { this.sendPreparePayment() })
    window.addEventListener('message', this.receiveMessage, false)
  }
}

</script>
<style lang="scss">
.v-dialog {
  overflow: hidden;
}
</style>
